import { render, staticRenderFns } from "./CapacityPage.vue?vue&type=template&id=3f461321"
import script from "./CapacityPage.vue?vue&type=script&lang=js"
export * from "./CapacityPage.vue?vue&type=script&lang=js"
import style0 from "./CapacityPage.vue?vue&type=style&index=0&id=3f461321&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports